import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "The Operations Audit Call",
    body: "We start with a conversation — reviewing your online presence, identifying the gaps, and determining whether automation or a personalized manual approach best fits your budget and goals.",
  },
  {
    n: "02",
    title: "Building the Infrastructure",
    body: "Once you select your package, we set up your custom automation engine — connecting your Google Business Profile and designing review templates in your brand's unique voice.",
  },
  {
    n: "03",
    title: "The 14-Day Review Pulse",
    body: "We initiate a targeted \"Pulse\" campaign, respectfully reaching out to recent and past customers to jumpstart your profile with fresh, high-quality reviews for an instant visibility boost.",
  },
  {
    n: "04",
    title: "Ongoing Concierge Management",
    body: "You get back to business; we manage the feedback — monitoring reviews, executing public responses, flagging private resolutions, and delivering monthly growth reports.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative grain bg-[var(--charcoal)] text-[var(--cream)] py-24 lg:py-36 overflow-hidden"
    >
      <div className="beam-glow pointer-events-none absolute inset-0 opacity-70" />
      <div className="container-luxe relative z-10">
        <div className="max-w-3xl">
          <Reveal>
            <p className="overline text-[var(--gold-soft)]">The Booking &amp; Onboarding Process</p>
            <h2 className="mt-5 serif text-[clamp(2rem,4.5vw,3.8rem)] leading-[1.03] tracking-tight text-[var(--cream)]">
              Designed like a <span className="italic gold-shimmer">5-star check-in.</span>
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-[var(--cream)]/70">
              Partnering with Beam Concierge is seamless, welcoming, and entirely
              stress-free — exactly how it should feel.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div
                data-testid={`process-step-${s.n}`}
                className="group h-full bg-[var(--charcoal)] p-8 lg:p-9 transition-colors duration-500 hover:bg-white/[0.03]"
              >
                <p className="text-xs uppercase tracking-[0.24em] text-[var(--gold-soft)]">
                  Step {s.n}
                </p>
                <p className="mt-6 serif text-5xl text-white/12 group-hover:text-[var(--gold-soft)]/30 transition-colors duration-500">
                  {s.n}
                </p>
                <h3 className="mt-4 serif text-xl text-[var(--cream)]">{s.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-[var(--cream)]/65">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
